import * as React from 'react'
import Body from 'shared/views/404/components/Body/Body'
import Footer from 'shared/views/404/components/Footer/Footer'
import PageTitle from 'components/PageTitle/PageTitle'
import { getUrlParam } from 'utils/misc'
import { RouteComponentProps } from 'react-router-dom'
import { TRANSLATIONS_TYPE } from 'shared/views/404/constants'
import { useTranslation } from 'react-i18next'
import 'components/Footer/Footer.scss'
import 'components/MainContent/MainContent.scss'
import 'components/ViewWrapper/ViewWrapper.scss'
import 'shared/views/404/404.scss'

const T_ROOT = 'pages.view404'

const Oops = ({ match: { path } }: RouteComponentProps): JSX.Element => {
  const { t } = useTranslation()
  const origin = getUrlParam(location.search).get('retry_url') || '/'
  const translationsType = TRANSLATIONS_TYPE[path]
  const handleTryAgain = (): void => location.assign(decodeURIComponent(origin))

  return (
    <div data-testid='oops' className='MainContent'>
      <div className='center-sm center-md center-lg full-width row no-margin'>
        <div className={'ViewWrapper View404 col-xs-12 col-sm-12 col-md-10 col-lg-9'}>
          <PageTitle title={t(`${T_ROOT}.${translationsType}.description`)} />
          <Body {...{ handleTryAgain, translationsType }} />
        </div>
        <div className='Footer View404-Footer'>
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default Oops
